import { Injectable } from '@angular/core';
import { IContract, ISharedCards } from '@app/shared/models/contract.model';
import { BehaviorSubject } from 'rxjs';
import { IClearContext } from './interface/iclear-context.interface';

@Injectable({
  providedIn: 'root',
})
export class ContractContext implements IClearContext {
  private readonly _contracts$ = new BehaviorSubject<IContract[] | null>(null);
  public contracts$ = this._contracts$.asObservable();

  private readonly _selectedContract$ = new BehaviorSubject<IContract | null>(null);
  public selectedContract$ = this._selectedContract$.asObservable();

  private readonly _sharedCards$: BehaviorSubject<ISharedCards | null> = new BehaviorSubject<ISharedCards | null>(null);
  public sharedCards$ = this._sharedCards$.asObservable();

  constructor() {}

  public clearContext(): void {
    this._contracts$.next(null);
    this._selectedContract$.next(null);
  }

  //#region Contracts and Balance

  public setContracts(value: IContract[]): void {
    this._contracts$.next(value);
  }

  public getContracts(): IContract[] | null {
    return this._contracts$.getValue();
  }

  public getContract(contractCode: string): IContract | null {
    return this._contracts$.getValue()?.find(c => c.contract_code === contractCode) || null;
  }

  //#endregion

  public setSelectedContract(contractCode: string): void {
    const contract = this.getContract(contractCode);
    this._selectedContract$.next(contract);
  }

  //#region Contract Change

  private _contractChanged$ = new BehaviorSubject<IContract | null>(null);
  public contractChanged$ = this._contractChanged$.asObservable();

  contractChange(contract: IContract | null = null): void {
    this._contractChanged$.next(contract);
  }

  getCurrentContract(): IContract | null {
    return this._contractChanged$.getValue();
  }

  //#endregion

  //#region shared cards

  public setSharedCards(value: ISharedCards): void
  {
    this._sharedCards$.next(value);
  }

  public getSharedCards(): ISharedCards | null {
    return this._sharedCards$.getValue()
  }

  //#endregion

  clear(): void {
    this._contractChanged$.next(null);
    this._selectedContract$.next(null);
    this._contracts$.next(null);
    this._sharedCards$.next(null);
  }
}
